import {
  ChangeDetectionStrategy, Component, input
} from '@angular/core';

import { environment } from '../../../environments/environment';

/** The you-are-not-on-prod marker: a caution stripe across the very top of
 *  the viewport with a small tag hanging from it. Driven by the build's
 *  environment file, so production builds render nothing at all. */
@Component({
  selector: 'app-env-badge',
  template: `
    @if (label(); as env) {
      <div class="env-stripe" aria-hidden="true"></div>
      <div class="env-tag" role="note">{{ env }} environment</div>
    }
  `,
  styleUrl: './env-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnvBadgeComponent {
  /** Overridable for tests; real builds read the environment file. */
  readonly label = input<string | null>(environment.envLabel);
}
